import * as apicall from "../components/Apicall";

/* Booking invoices (ezp_invoices). Generation is still apicall.generate_pdf("generate_pdf");
   these cover the cancel side. Both endpoints are admin / vendor only. */

// Everything a cancel would touch: the invoice and every booking tied to it.
// Pass either the invoice id or any one of its booking ids.
export const getInvoiceImpact = ({ invoiceId, bookingId }) => {
  const qs = invoiceId ? `invoice_id=${invoiceId}` : `booking_id=${bookingId}`;
  return apicall.get(`invoice_impact?${qs}`);
};

// Marks the invoice VOID and frees all its bookings. reason is required.
export const cancelInvoice = (invoiceId, reason) =>
  apicall.post({ invoice_id: invoiceId, reason }, "cancel_ezp_invoice");

// generate_pdf rejects with "Server error: 409 - {json}"; the API's own message
// (e.g. "Already invoiced (INV-2026-000012). Cancel the invoice first ...") is inside.
export const invoiceErrorMessage = (err, fallback = "Invoice generation failed") => {
  const raw = String(err?.message || err || "");
  const match = raw.match(/- (\{.*\})\s*$/s);
  if (match) {
    try {
      return JSON.parse(match[1]).message || fallback;
    } catch {
      /* fall through */
    }
  }
  return raw || fallback;
};
